import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {SynapiItem} from "../../../models/Synapi/SynapiItem";
import {CommonModule} from "@angular/common";
import {RouterLink} from "@angular/router";
import {MediaAttachmentComponent} from "../media-attachment/media-attachment.component";
import {SynapiBookmarkToggleComponent} from "../synapi-bookmark-toggle/synapi-bookmark-toggle.component";
import {LanguageService} from "../../../services/language.service";
import {SynapiItemLabelComponent} from "../synapi-item-label/synapi-item-label.component";


@Component({
  selector: 'synapi-item',
  templateUrl: './synapi-item.component.html',
  standalone: true,
    imports: [CommonModule, MediaAttachmentComponent, RouterLink, SynapiBookmarkToggleComponent, SynapiItemLabelComponent],
  styleUrls: ['./synapi-item.component.scss']
})

export class SynapiItemComponent implements OnChanges{
    @Input() item: SynapiItem;
    stars : any[];
    labels : any[];

    constructor(public langService : LanguageService) { }
    ngOnChanges(changes:SimpleChanges) {
      if(changes['item'].isFirstChange()){
        const stars = this.item.Classements.find((c)=>c.id.includes("etoiles"));
        if(stars){
          this.stars = Array(stars.Valeur);
        }
        const labels = this.item.Labels;
        if(labels){
          const labelHandicap = "labels-marques-et-sites-classes.accessibilite-et-handicap.label-tourisme-et-handicap";
          const labelVarAccessible = "labels-marques-et-sites-classes.accessibilite-et-handicap.label-var-accessible";
          this.labels = [];
          for(let label of labels){
            if(label.id.startsWith(labelHandicap)){
              label.id = labelHandicap;
              label.name = "Tourisme et handicap";
            }
            if(label.id.startsWith(labelVarAccessible)){
              label.id = labelVarAccessible;
              label.name = "Var accessible";
            }
            if(!this.labels.find((l)=>l.id === label.id)){
              this.labels.push(label);
            }
          }
        }
      }

    }
}
